import React, { Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { Typography } from '@material-ui/core';

class DetailUnscheduledList extends Component {

    render() {
        const listItems = this.props.events.map((event, i) => {
            return (
                <ListItem key={i}>
                    <ListItemIcon>
                        <b>{i + 1}</b>
                    </ListItemIcon>
                    <ListItemText>
                        <SnackbarContent message={event.title} />
                    </ListItemText>
                </ListItem>
            )
        })

        if (this.props.events.length === 0) {
            return (
                <Typography>This lesson has no events.</Typography>
            )
        }

        return (
            <List>
                {listItems}
            </List>
        )
    }
}

export default DetailUnscheduledList;


// WEBPACK FOOTER //
// src/main/content/lesson/ScheduleComponents/DetailUnscheduledList.js